import { useEffect } from 'react';

import { closeOpenSelectMenus } from '../utils';

/**
 * Closes any open Select menus inside `scrollContainerRef` when that container scrolls.
 * Use with portaled menus so they dismiss when the filter field scrolls out of view,
 * without clipping the menu against intermediate section overflow containers.
 */
export default function useCloseOpenSelectsOnScroll(scrollContainerRef) {
    useEffect(() => {
        const container = scrollContainerRef?.current;
        if (!container) {
            return undefined;
        }

        const handleScroll = () => {
            closeOpenSelectMenus(container);
        };

        container.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, [scrollContainerRef]);
}
